import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { InPersonUrgentCareOptionCardComponent } from "../in-person-urgent-care-option-card/in-person-urgent-care-option-card.component";
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../../../environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-in-person-urgent-care',
  imports: [CommonModule, TranslateModule, MatCardModule, MatButtonModule, InPersonUrgentCareOptionCardComponent, MatProgressSpinnerModule],
  templateUrl: './in-person-urgent-care.component.html',
  styleUrl: './in-person-urgent-care.component.css'
})
export class InPersonUrgentCareComponent {
  @Input() locale: string | null = null;
  @Input() inpersonUrgentCareOptions: any[] = [];

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  public showMoreText: string = 'SHOW_MORE';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided
  }
  
  ngOnInit(): void {
    this.translate.get('INPERSONURGENTCARE.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('INPERSONURGENTCARE.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });

    this.translate.get('SHOW_MORE').subscribe((translated: string) => {
      this.showMoreText = translated;
    }); 

  }

  showMeMore() {
    const eptID = sessionStorage.getItem("eptID");

    if (eptID == null || eptID == undefined || eptID == "") {
      this.showMeMoreUnAuth();
    }
    else {
      this.showMeMoreAuth();
    }
  }

  showMeMoreUnAuth() {
    // Logic to show more options or details for unauthenticated users
    var deepLink = environment.web_unauth_omw_deep_link_base_url;
    deepLink += "?linksource=PLUAIPUC";

    this.monitoringService.logEvent('ShowMore/NoAuth', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
    
    console.log("Show me more clicked (IPUC)");
    console.log(deepLink);

    window.location.href = deepLink;
  }


  showMeMoreAuth() {
    // Logic to show more options or details
    console.log("Show me more clicked");

    var deepLink = environment.web_omw_deep_link_base_url; // For web users, use the web deep link
    deepLink += "?linksource=AUTHIPUCRESERVE";

    this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event

    window.location.href = deepLink;
  }
}
